// managementSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { setLoading } from "../loading/loadingSlice";
import { setError, clearError } from "../error/errorSlice";

// Import the CORRECT function that supports sorting
import {
  fetchManagementCompanies as fetchManagementCompaniesWithSort,
  fetchAllCompanies as fetchAllManagementCompaniesFromAPI,
} from "../../pages/setup/components/managementcompanies/services/managementService";

const initialState = {
  companies: [],
  allCompanies: [],
  loading: false,
  error: null,
  totalPages: 1,
};

export const fetchManagementCompanies = createAsyncThunk(
  "management/fetchCompanies",
  // Now include sortField, sortOrder in the payload
  async (
    { currentPage, rowsPerPage, searchQuery, sortField, sortOrder },
    thunkAPI
  ) => {
    const { dispatch } = thunkAPI;
    try {
      // dispatch(setLoading(true));
      dispatch(clearError());
      // Call the correct function that accepts sorting parameters
      const data = await fetchManagementCompaniesWithSort(
        currentPage,
        rowsPerPage,
        searchQuery,
        sortField,
        sortOrder
      );
      return data;
    } catch (error) {
      dispatch(setError(error.message));
      return thunkAPI.rejectWithValue(error.message);
    }
    // finally {
    //   // dispatch(setLoading(false));
    // }
  }
);

export const fetchAllManagementCompanies = createAsyncThunk(
  "management/fetchAllCompanies",
  async (_, thunkAPI) => {
    const { dispatch } = thunkAPI;
    try {
      // dispatch(setLoading(true));
      dispatch(clearError());
      // Assuming you have a new service function for fetching all companies
      const data = await fetchAllManagementCompaniesFromAPI();
      return data; // expecting an array of companies
    } catch (error) {
      dispatch(setError(error.message));
      return thunkAPI.rejectWithValue(error.message);
    }
    // finally {
    //   dispatch(setLoading(false));
    // }
  }
);

const managementSlice = createSlice({
  name: "management",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchManagementCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchManagementCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companies = action.payload.content;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchManagementCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAllManagementCompanies.fulfilled, (state, action) => {
        state.allCompanies = action.payload;
      });
  },
});

export const selectCompanies = (state) => state.management.companies;
export const selectAllCompanies = (state) => state.management.allCompanies;
export const selectTotalPages = (state) => state.management.totalPages;
export const selectLoading = (state) => state.management.loading;

export default managementSlice.reducer;
